import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Table } from 'reactstrap';
import LoadingSpin from "react-loading-spin";
import moment from 'moment';

export class StuCheckCart extends Component {
    static displayName = StuCheckCart.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            permissionFlag: true,
            advisorTable: [],
            semesterTable: []
        }
        this.getData();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data
        }, () => {
            this.recordComingHere();
            this.testPermission();
            this.getAdvisorAuth();
        })
    }

    async recordComingHere() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            pagePK: "1040",
            department: this.state.returnable.level,
            userPCID: this.state.returnable.pcid,
            ip: this.state.ip,
            browser: this.state.browser,
            userID: this.state.returnable.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "1040"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async getAdvisorAuth() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {//for getAdvisorAuth() and getCartData() I don't actually need to send anything since I don't need any authn/authz on these, but I may in the future so I'll put it in here for when I do
                        //If a user without cart data hits this page they just won't see anything, which is okay. This is primarily meant to get students away from Krypton where they're able to use a URL
                        //manipulation process too see other students' carts, and since this fetch is deriving PCID by logged in user it'll only ever be displaying the logged in user's cart. In order to
                        //use this to see a different student's cart they'd have to steal that student's login credentials at which point any security safeguards I write will be meaningless.
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetStuAdvisorAuth', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            advisorTable: data
        }, () => { this.getCartData(); })
    }

    async getCartData() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetStuCartData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            semesterTable: data,
            loading: false
        })
    }

    componentDidMount() {

    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
        //There are a fair amount of formatting things going on in here that I don't fully comprehend, but I replicated them here because that's what the Krypton report looked like so okay.
        return (<div>
            <div><h2 style={{ color: "#00a9d3" }}>Cart check for common registration errors</h2><p /></div>
            <span>Errors displayed here <b><u>must</u></b> be addressed or the courses removed from your cart before online registration can be completed.</span><p />
            <br />
            {this.state.loading && <LoadingSpin size="30px" primaryColor="#86d3ff" />}
            {!this.state.loading && <Table bordered>
                <thead style={{ backgroundColor: "#00a9d3", color: "#ffffff" }}>
                    <tr>
                        <th>Term</th>
                        <th>Advisor Name</th>
                        <th>Authorization Status</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.advisorTable.map(item => (
                        <tr>
                            <td>{item.acterm} {item.acyear}</td>
                            <td>{item.advisorname}</td>
                            <td><span style={{ color: !isNaN(parseFloat(item.regauthid)) && isFinite(item.regauthid) ? 'green' : 'red' }} > {item.authstatus}</span></td>
                        </tr>
                    ))}
                </tbody>
            </Table>}
            <br />
            {!this.state.loading && <Table bordered>
                <thead style={{ backgroundColor: "#00a9d3", color: "#ffffff" }}>
                    <tr>
                        <th>Term</th>
                        <th>Course</th>
                        <th>Requirement</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.semesterTable.map(item => (
                        <tr>
                            <td>{item.yearterm}</td>
                            <td><span style={{ color: (item.validation != "No conflicts" && (item.reqmet == "" || item.reqmet == "Requirement not met")) ? 'red' : '' }}><b>{item.eventdata}</b></span></td>
                            <td><span style={{ color: (item.validation != "No conflicts" && (item.reqmet == "" || item.reqmet == "Requirement not met")) ? 'red' : '' }}><b>{item.requirement}</b></span></td>
                            <td><span style={{ color: (item.validation != "No conflicts" && (item.reqmet == "" || item.reqmet == "Requirement not met")) ? 'red' : '' }}><b>{item.validation}</b></span></td>
                        </tr>
                    )) }
                </tbody>
            </Table>}
            <div className="rightAlignCustom"><a href="https://selfservice.hood.edu/SelfService/">Return to SelfService =&gt;</a></div>{/*This goes directly to the cart on Krypton, but since this isn't a target=_blank I figured to make it go to Home*/ }
            <br />
            <br />
        </div>);
    }
}